import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from 'components/Dashboard/Dashboard.container';
import DashboardStore from 'components/Dashboard/Store';
import DashboardHeader from 'components/Dashboard/Header';
import { Products } from 'components/Dashboard/Store/Products/Products.container';
import { useStoreDetails } from 'api/store';
import { Spin } from 'antd';

const DashboardStorePage = () => {
  const params = useParams();

  const storeId = useMemo(() => (params.storeId ? Number(params.storeId) : null), [params]);
  const category = useMemo(() => (params.category ? params.category : 'all'), [params]);

  const { data: storeData, isLoading } = useStoreDetails(storeId, true);

  if (!storeData || isLoading) {
    return <Spin spinning={isLoading} />;
  }

  return (
    <Dashboard page="products" storeId={storeId} doShowHeader>
      <DashboardHeader store={storeData} />
      <DashboardStore
        page={category}
        storeId={storeId}
        hasClosedTutorial={storeData?.hasClosedTutorial}
      >
        {(products, newLocalProducts, isLoading, mutate, productsAreReordering) =>
          storeData && (
            <Products
              store={storeData}
              products={products}
              newLocalProducts={newLocalProducts}
              isLoading={isLoading}
              mutateProducts={mutate}
              productsAreReordering={productsAreReordering}
            />
          )
        }
      </DashboardStore>
    </Dashboard>
  );
};

export default DashboardStorePage;
